import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { getBuilderModelName } from "@/libs/builder/tools/getBuilderModelName";
import { createConsumablesProductDefaultDataBinding } from "@/libs/commerce/ConsumablesProductContent";

import {
  ALL_CONSUMABLES_PRODUCT_DETAILS_CONTAINER_INPUTS,
  CONSUMABLES_PRODUCT_DETAILS_CONTAINER_BINDINGS_INPUTS,
} from "./ConsumablesProductDetailsContainer.inputs.builder";

export const ConsumablesProductDetailsContainerComponent: RegisteredComponent =
  {
    name: "ConsumablesProductDetailsContainer",
    friendlyName: "Consumables Product Details Container",
    component: dynamic(
      async () =>
        (await import("./ConsumablesProductDetailsContainer"))
          .ConsumablesProductDetailsContainer
    ),
    models: [getBuilderModelName("product")],
    defaults: {
      bindings: createConsumablesProductDefaultDataBinding<
        typeof CONSUMABLES_PRODUCT_DETAILS_CONTAINER_BINDINGS_INPUTS
      >({
        sku: "productSku",
        badgeText: "productBadgeText",
        description: "productDescription",
        shortDescription: "productShortDescription",
        knowMoreUrl: "productKnowMoreUrl",
        multiPackDescription: "productMultiPackDescription",
        productCta: "productCta",
        productName: "productName",
        isCommerceDisabled: "productIsCommerceDisabled",
        isMultiPackEnabled: "productIsMultiPackEnabled",
        multiPackName: "productMultiPackName",
        multiPackProducts: "productMultiPackProducts",
        customBuyCtaLabel: "productCustomBuyCtaLabel",
        consumablesMatrixData: "productConsumablesMatrixData",
        isSubscriptionsEnabled: "productIsSubscriptionsEnabled",
      }),
    },
    inputs: ALL_CONSUMABLES_PRODUCT_DETAILS_CONTAINER_INPUTS,
  };
